module.exports = __webpack_public_path__ + "static/media/clockOrange.146b7b95.svg";